<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="车场分组" prop="communityGroup">
              <el-select style="width: 100%" v-model="form.communityGroup" @change="communityGroupChange">
                <el-option
                  v-for="item in communityGroupList"
                  :key="item"
                  :value="item.dictKey"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="停车场"
              prop="spaceId"
              :rules="[{ required: true, message: '请选择停车场', trigger: 'blur' }]"
            >
              <el-select
                multiple
                v-model="form.spaceId"
                filterable
                collapse-tags
                style="margin-left: 20px"
                placeholder="请选择"
                @change="spaceIdChange"
              >
                <el-option
                  v-for="item in spaceList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="支付时间开始"
              prop="payTimeStrat"
              :rules="[{ required: true, message: '请选择支付时间', trigger: 'blur' }]"
            >
            <el-date-picker
              style="width:100%;"
              v-model="form.payTimeStrat"
              type="datetime"
              default-time="00:00:00"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
              placeholder="开始日期"

            >
            </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="支付时间结束"
              prop="payTimeEnd"
              :rules="[{ required: true, message: '请选择支付时间', trigger: 'blur' }]"
            >
            <el-date-picker
              style="width:100%;"
              v-model="form.payTimeEnd"
              type="datetime"
              default-time="23:59:59"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
              placeholder="开始日期"

            >
            </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="6">
            <el-form-item label="支付方式" prop="payType">
              <el-select
                v-model="form.payType"
                filterable
                collapse-tags
                style="margin-left: 20px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in payList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="车位性质" prop="feeNature">
              <el-select
                v-model="form.feeNature"
                filterable
                collapse-tags
                style="margin-left: 20px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in feeNatureList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="车位编号">
              <el-input v-model="form.parkingSpaceName"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="票据号">
              <el-input v-model="form.invoiceNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item style="float:right">
              <el-button type="primary" @click="onSubmit">立即查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params" :roomName="roomName" :name="name" />
    </basic-container>
  </div>
</template>

<script>
import WebReport from '@/components/web-report';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import urlSettings from '@/config/url-settings.js';
export default {
  components: {
    WebReport,
  },
  data() {
    //设置默认时间
    const myDate = new Date();
    const year = myDate.getFullYear();
    const month =
      myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1;
    const day = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
    const startDay = year + '-' + month + '-01 00:00:00';
    const endDay = year + '-' + month + '-' + day + ' 23:59:59';

    return {
      url: '',
      communityGroup: "",
      form: {
        payTime: [startDay, endDay],
        spaceId: [],
        payType: '',
        feeNature: '',
        parkingSpaceName: '',
        orderNum: '',
        invoiceNo: '',
        payTimeStrat: '',
        payTimeEnd: '',
      },
      payList: [
        { dictValue: '全部', dictKey: '' },
        { dictValue: '现金支付', dictKey: '1' },
        { dictValue: '微信支付', dictKey: '2' },
        { dictValue: '支付宝支付', dictKey: '3' },
      ],
      feeNatureList: [
        { dictValue: '全部', dictKey: '' },
        { dictValue: '车位费', dictKey: '1' },
        { dictValue: '车库物业费', dictKey: '2' },
      ],
      spaceList: [],
      oldOptions: [],
      params: {
        reportlet:'pmsone_cjwy/v2/parkingSpaceFeeDetailV3.cpt',
      },
      dic: [],
      communityGroupList:[
        {
          dictKey:'1',
          dictValue:'住宅事业部一部',
        },
        {
          dictKey:'2',
          dictValue:'住宅事业部二部',
        },
      ],
    };
  },
  methods: {
    communityGroupChange(){
      this.initPropertyList();
    },
    spaceIdChange(val) {
      let allValues = []; //保留所有值
      let value = []; //保留所选的值

      for (let item of this.spaceList) {
        allValues.push(item.id);
      }
      // 用来储存上一次的值，可以进行对比
      const oldVal = this.oldOptions;

      // 若是全部选择
      if (val.indexOf('0000') != -1) {
        value = allValues;
      }

      // 取消全部选中  上次有 当前没有 表示取消全选
      if (oldVal.indexOf('0000') != -1 && val.indexOf('0000') == -1) {
        value = [];
      }

      // 点击非全部选中  需要排除全部选中 以及 当前点击的选项
      // 新老数据都有全部选中
      if (oldVal.indexOf('0000') != -1 && val.indexOf('0000') != -1) {
        if (val.length < allValues.length) {
          const index = val.indexOf('0000');
          val.splice(index, 1); // 排除全选选项
          value = val;
        } else {
          value = val;
        }
      }

      //全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
      if (oldVal.indexOf('0000') == -1 && val.indexOf('0000') == -1) {
        if (val.length === allValues.length - 1) {
          value = ['0000'].concat(val);
        } else {
          value = val;
        }
      }

      //储存当前最后的结果 作为下次的老数据
      this.oldOptions = value;
      this.form.spaceId = value;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.spaceId = `(${this.form.spaceId.join(',')})`;
          this.params.payType = this.form.payType;
          this.params.feeNature = this.form.feeNature;
          this.params.parkingSpaceName = this.form.parkingSpaceName;
          this.params.invoiceNo = this.form.invoiceNo;
          this.params.payTimeStrat = this.form.payTimeStrat;
        this.params.payTimeEnd = this.form.payTimeEnd;
          var reportUrl = urlSettings.BASE_REPORT_URL;
          this.url = reportUrl.split('?')[0];
          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    initPropertyList() {
      this.form.spaceId = [];
      getSpaceTree(null, this.form.communityGroup).then((data) => {
        this.spaceList = data.data;
        let obj = {};
        obj.title = '全部';
        obj.id = '0000';
        this.spaceList.unshift(obj);
        this.form.spaceId.push(this.spaceList[1].id);
        this.form.payTimeStrat = this.form.payTime[0];
        this.form.payTimeEnd = this.form.payTime[1];

        this.params.spaceId = `(${this.spaceList[1].id})`;
        this.params.payTimeStrat = this.form.payTimeStrat;
        this.params.payTimeEnd = this.form.payTimeEnd;
        console.log('初始化月卡车收费明细请求参数：' + this.params);

        var reportUrl = urlSettings.BASE_REPORT_URL;
        this.url = reportUrl.split('?')[0];
        setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });
    },
  },

  created() {
    this.form.communityGroup = '1';
    this.initPropertyList();
  },
};
</script>

<style></style>
